<template>
  <v-container fluid>
    <v-row>
      <v-col md="6" cols="12">
        <base-material-card color="primary" icon="mdi-account-group" inline class="px-5 py-3" title="Informações básicas">
          <v-row class="mt-5">
            <v-col cols="12">
              <validation-provider v-slot="{ errors }" rules="required" name="Titulo">
                <v-text-field v-model="profileInfo.title" label="Titulo" outlined :error-messages="errors" />
              </validation-provider>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <validation-provider v-slot="{ errors }" rules="required" name="Descrição">
                <v-textarea v-model="profileInfo.description" label="Descrição" outlined :error-messages="errors" />
              </validation-provider>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-btn color="primary" min-width="100" style="float: right" class="mr-0 mt-n5" :loading="loading" @click="save()">
                Salvar
              </v-btn>
            </v-col>
          </v-row>
        </base-material-card>
      </v-col>
      <v-col md="6" cols="12">
        <base-material-card
          color="primary"
          icon="mdi-format-list-bulleted"
          inline
          class="px-5 py-3"
          style="min-height: 600px"
          title="Páginas de Acesso"
        >
          <v-row>
            <v-col cols="12">
              <v-text-field
                id="routes-search"
                v-model="search"
                append-icon="mdi-magnify"
                class="break-search bs-perfil ml-auto mt-4"
                label="Procurar"
                hide-details
                single-line
              />
              <v-divider class="mt-10" />
              <v-data-table
                :value="urlSelected"
                :headers="headers"
                :items="routes"
                :search.sync="search"
                show-select
                item-key="name"
                :headerProps="{
                  sortByText: 'Ordenar Por'
                }"
                :sort-by="['name']"
                :loading="loading"
                :disable-pagination="true"
                :hide-footer="true"
                :hide-default-header="loading"
                :hide-default-footer="true"
                no-results-text="Nenhum registro correspondente encontrado"
                class="overflow-auto"
                @input="atualizarRotasSelecionadas"
              />
            </v-col>
          </v-row>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import PerfisUsuariosService from '@/services/PerfisUsuariosService';
  import routes from '@/store/modules/routes';

  const rotasGestaoBdgd = [routes.state.appRoutes['BDGDS_TAREFAS'], routes.state.appRoutes['GESTAO_BDGDS_TAREFAS']];

  export default {
    data: () => ({
      loading: false,
      search: '',
      profileInfo: {
        id: null,
        title: null,
        description: null,
        urls: []
      },
      urlSelected: [],
      routes: [],
      headers: [
        {
          text: 'Página',
          value: 'name'
        },
        {
          text: 'Url',
          value: 'url'
        }
      ]
    }),

    computed: {
      profileId() {
        return this.$route.params.id;
      }
    },

    mounted() {
      if (this.profileId) {
        this.getPerfilUsuario(this.profileId);
      }
      this.getRoutes();
    },

    methods: {
      getRoutes() {
        this.$router.options.routes.forEach((route) => {
          if (
            route.path === '/home' ||
            route.path === '/login' ||
            route.path === '/perfil' ||
            route.path === '/admin' ||
            route.path === '*' ||
            route.path === '/'
          ) {
            return;
          }

          route.children.forEach((child) => {
            this.routes.push({
              name: child.name,
              url: `${route.path}/${child.path.replace(/\/:[^/]+$/, '')}`
            });
          });
        });
      },

      getPerfilUsuario(profileId) {
        this.loading = true;

        PerfisUsuariosService.getPerfilUsuarioById(profileId)
          .then(({ data }) => {
            const info = data.data[0];
            this.profileInfo = info;
            this.setUrlSelected(info.urls);
          })
          .catch(() =>
            this.$toast.error('Erro ao recuperar os dados do perfil do usuário.', '', {
              position: 'topRight'
            })
          )
          .finally(() => {
            this.loading = false;
          });
      },

      setUrlSelected(urls) {
        urls.forEach((url) => {
          this.urlSelected.push({
            name: url.route_name
          });
        });
      },

      atualizarRotasSelecionadas(rotasSelecionadas) {
        const selecionadas = Array.isArray(rotasSelecionadas) ? rotasSelecionadas : [];
        const rotaGestaoAdicionada = selecionadas.find(
          (rota) => rotasGestaoBdgd.includes(rota.name) && !this.urlSelected.some((selecionada) => selecionada.name === rota.name)
        );

        if (!rotaGestaoAdicionada) {
          this.urlSelected = selecionadas;
          return;
        }

        const haviaRotaConflitante = this.urlSelected.some(
          (rota) => rotasGestaoBdgd.includes(rota.name) && rota.name !== rotaGestaoAdicionada.name
        );

        this.urlSelected = selecionadas.filter(
          (rota) => !rotasGestaoBdgd.includes(rota.name) || rota.name === rotaGestaoAdicionada.name
        );

        if (haviaRotaConflitante) {
          this.$toast.info(
            'As permissões de analista e administrador da Gestão da BDGD não podem ser atribuídas ao mesmo perfil.',
            '',
            { position: 'topRight' }
          );
        }
      },

      save() {
        this.profileInfo.urls = [];

        this.urlSelected.forEach((url) => {
          this.profileInfo.urls.push(url.name);
        });

        const data = this.profileInfo;

        this.loading = true;

        PerfisUsuariosService.save(data)
          .then(() => {
            this.$toast.success('Perfil de Usuário salvo com sucesso.', '', {
              position: 'topRight'
            });
            this.$router.push({
              name: routes.state.appRoutes['PERFIS_USUARIOS_LISTAR']
            });
          })
          .catch((err) => {
            console.error(err);
            const mensagem = err?.response?.data?.errors?.urls?.[0] || 'Erro ao salvar perfil de usuário.';

            this.$toast.error(mensagem, '', {
              position: 'topRight'
            });
          })
          .finally(() => (this.loading = false));
      }
    }
  };
</script>

<style scoped>
  .overflow-auto {
    max-height: 400px;
    overflow-y: auto;
  }
</style>
